<div>
    <div *ngIf="!dataLoading">
        <kendo-grid [kendoGridBinding]="gridView" [pageable]="true" [pageSize]="state.take" [skip]="state.skip"
            [scrollable]="'true'" [sortable]="true" [resizable]="true" [filter]="state.filter" [sort]="state.sort"
            (remove)="removeHandler($event)" (edit)="editHandler($event)">
            <ng-template kendoGridToolbarTemplate id="enrol-mobile-view-msg">
                <div class="row bottom-margin-0" id="enrol-mobile-view-msg">
                    <p class="text-red"><span class="k-icon k-i-warning"></span>Add/Edit adjustment will
                        not be available on Mobile Devices</p>
                </div>
            </ng-template>
            <!-- MOBILE VIEW -->
            <kendo-grid-column media="(max-width: 772.98px)" title="Details" [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <dl>
                        <dd>
                            <div class="align-left">
                                <span class="bold">SSN4: </span>
                                <span> {{ dataItem.lastFourSSN }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">First Name: </span>
                                <span> {{ dataItem.firstName }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Middle Initial: </span>
                                <span> {{ dataItem.MI }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Last Name: </span>
                                <span> {{ dataItem.lastName }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Submitted On: </span>
                                <span> {{ dataItem.dateSubmitted | date: 'MM/dd/yyyy' }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Last Modified: </span>
                                <span> {{ dataItem.lastModified | date: 'MM/dd/yyyy' }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Submitted By: </span>
                                <span> {{ dataItem.submittedBy }}</span>
                            </div>
                        </dd>
                        <dd>
                            <div class="align-left">
                                <span class="bold">Status: </span>
                                <span> {{ dataItem.status }}</span>
                            </div>
                        </dd>
                    </dl>
                </ng-template>
            </kendo-grid-column>
            <!-- DETAIL VIEW -->
            <ng-template kendoGridDetailTemplate let-dataItem>
                <div class="row">
                    <div class="col s12 m12 l12 xl12">
                        <!-- TODO: Detail view component -->
                        <app-pending-detailed-view [data]="dataItem"></app-pending-detailed-view>
                    </div>
                </div>
            </ng-template>
            <!-- ACTIONS -->
            <kendo-grid-command-column title="" media="(min-width: 773px)" [width]="50"
                *ngIf="operators.Edit || operators.Delete">
                <ng-template kendoGridCellTemplate let-isNew="isNewUser" let-dataItem>
                    <div *ngIf="dataItem.submittedDate === null">
                        <div class="align-center"
                            *ngIf="!dataItem.isEditable || !dataItem.isAuthorizedOwner; else actionBtns" kendoTooltip>
                            <a (click)="assignToYourself(dataItem)" *ngIf="operators.Edit" id="editBtn">
                                <span class="k-icon k-i-track-changes-accept link-icon"
                                    title="Assign to yourself"></span>
                            </a>
                        </div>
                        <ng-template #actionBtns>
                            <div class="align-center" kendoTooltip>
                                <button kendoGridEditCommand id="editBtn" *ngIf="operators.Edit"
                                    [disabled]="!dataItem.isAuthorizedOwner">
                                    <span type="button"
                                        [ngClass]="dataItem.isAuthorizedOwner ? 'link-icon' : 'link-icon-disabled'"
                                        class="k-icon k-i-edit" title="Edit"></span>
                                </button>
                                <button kendoGridRemoveCommand id="removeBtn" *ngIf="operators.Delete"
                                    [disabled]="!dataItem.isAuthorizedOwner">
                                    <span type="button"
                                        [ngClass]="dataItem.isAuthorizedOwner ? 'link-icon' : 'link-icon-disabled'"
                                        class="k-icon k-i-delete" title="Delete"></span>
                                </button>
                            </div>
                        </ng-template>
                    </div>
                </ng-template>
            </kendo-grid-command-column>
            <!-- SSN COLUMN -->
            <kendo-grid-column media="(min-width: 773px)" field="lastFourSSN" class="align-center" title="SSN4"
                [width]="50" [headerClass]="{'align-center': true}">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div class="align-center">
                        {{dataItem.lastFourSSN}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <!-- FIRST NAME -->
            <kendo-grid-column media="(min-width: 773px)" field="firstName" title="First Name"
                [width]="95"></kendo-grid-column>
            <!-- MI -->
            <kendo-grid-column media="(min-width: 773px)" field="mi" title="MI" [width]="40"
                [headerClass]="{'align-center': true}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="align-center">
                        <span>
                            {{dataItem.mi}}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <!-- LAST NAME -->
            <kendo-grid-column media="(min-width: 773px)" field="lastName" title="Last Name"
                [width]="95"></kendo-grid-column>
            <!-- SUBMITTED ON -->
            <kendo-grid-column field="submittedDate" media="(min-width: 773px)" title="Submitted On" [width]="75"
                [headerClass]="{'align-date': true}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="align-date">
                        <span>
                            {{dataItem.submittedDate | date: 'MM/dd/yyyy'}}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <!-- SUBMITTED BY -->
            <kendo-grid-column media="(min-width: 773px)" field="submittedBy" title="Submitted By" [width]="80"
                [filterable]="false"></kendo-grid-column>
            <!-- Modified On -->
            <kendo-grid-column field="modifiedDate" media="(min-width: 773px)" title="Modified On" [width]="70"
                [headerClass]="{'align-date': true}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="align-date">
                        <span>
                            {{dataItem.modifiedDate | date: 'MM/dd/yyyy'}}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <!-- LAST Modified BY -->
            <kendo-grid-column media="(min-width: 773px)" field="modifiedBy" title="Modified By" [width]="80"
                [filterable]="false"></kendo-grid-column>
            <!-- STATUS -->
            <kendo-grid-column media="(min-width: 773px)" field="status" title="Status"
                [headerStyle]="{'text-align': 'center'}" [width]="60" [filterable]="false">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div class="align-center">
                        <span>{{dataItem.status}}</span>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>

    <div class="k-icon k-i-loading outer" *ngIf="dataLoading"></div>

</div>

<!-- DELETE ENROLLMENT RECORD -->
<kendo-dialog title="Delete Record" *ngIf="deleteEnrollmentDialog" (close)="deleteEnrollmentDialog=false"
    [minWidth]="250" id="delete-adj-dialog" class="app-dialog">
    <p>{{config.DeletePendingEnrollMsg}}</p>
    <kendo-dialog-actions id="delete-adj-btns">
        <button kendoButton class="k-button" id="no-btn" [disabled]="loading" (click)="deleteEnrollmentDialog=false"
            primary="true">No</button>
        <button kendoButton class="k-button" id="yes-btn" [disabled]="loading" (click)="deleteEnrollmentRecord()"
            primary="true">
            <span *ngIf="!loading">Yes</span>
            <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>